import { Col, Collapse, Flex, Row } from 'antd'
import { CustomExpandIcon, UiText } from 'src/pages/budget/components'
import { CHILD_COLORS, PARENT_COLORS, STAGES } from 'src/pages/budget/const'
import { StageCard } from 'src/pages/budget/budgetTeams/components/stageCard'
import { TeamTree } from 'src/pages/budget/budgetTeams/types'

type PropsType = {
  team: TeamTree
}

const FONT_SIZES_MAP: Record<number, number> = {
  0: 28,
  1: 24,
  2: 20,
}

export const UnitCard = ({ team }: PropsType) => {
  const { id, name, permissions, parentTeamId, level, children } = team
  const colorIndex = level % 4

  return (
    <Collapse
      defaultActiveKey={!parentTeamId ? id : undefined}
      items={[
        {
          key: id,
          label: (
            <Flex align="center" gap={8}>
              <UiText size={FONT_SIZES_MAP[level] ?? 18}>{name}</UiText>
            </Flex>
          ),
          styles: {
            header: {
              backgroundColor: PARENT_COLORS[colorIndex],
            },
            body: {
              backgroundColor: CHILD_COLORS[colorIndex],
            },
          },
          children: (
            <>
              <Row gutter={16}>
                {STAGES.map((stage) => (
                  <Col span={8} key={stage}>
                    <StageCard
                      userIds={permissions[stage]}
                      teamId={id}
                      type={stage}
                      level={level}
                    />
                  </Col>
                ))}
              </Row>
              {children && (
                <Flex vertical gap={24} style={{ marginTop: 24 }}>
                  {children.map((team) => (
                    <UnitCard key={team.id} team={team} />
                  ))}
                </Flex>
              )}
            </>
          ),
        },
      ]}
      size="large"
      expandIcon={({ isActive }) => <CustomExpandIcon isActive={isActive} />}
      expandIconPosition="end"
    />
  )
}
